import { Box, IconButton } from '@material-ui/core';
import { CloseOutlined, LinkedIn } from '@material-ui/icons';
import MUIDataTable from 'mui-datatables'
import React from 'react'
import { updateObjectStateValue } from '../../../../utils/FunctionHelpers';

const Step3 = ({ importData, setImportData }) => {
    const handleDeleteContact = (data) => {
        const tmpContacts = importData.contactsToImport
        tmpContacts.splice(data.rowIndex, 1)
        updateObjectStateValue(
            setImportData,
            { contactsToImport: tmpContacts }
        )
    }

    const columns = [

        {
            name: "titre",
            label: "TITRE",
            options: {
              setCellHeaderProps: () => ({ style: { padding: "2px 12px", textAlign: "center", width: "10%" } }),
              setCellProps: () => ({ style: { padding: "0px 12px", whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", width: "10%" } }),
            },
        },
        {
            name: "prenom",
            label: "PRÉNOM",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "100px" }} title={value}>{value}</Box>
                    );
                },
            }
        },
        {
            name: "nom",
            label: "NOM",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "100px" }} title={value}>{value}</Box>
                    );
                },
            }
        },
        {
            name: "fonction",
            label: "FONCTION",
            options: {
                setCellHeaderProps: () => ({ style: { padding: "2px 12px", textAlign: "center", width: "30%" } }),
                setCellProps: () => ({ style: { padding: "0px 12px", whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", width: "30%" } }),
            },
        },
        {
            name: "mobile",
            label: "MOBILE",
            options: {
                setCellHeaderProps: () => ({ style: { padding: "2px 12px", textAlign: "center", width: "30%" } }),
                setCellProps: () => ({ style: { padding: "0px 12px", whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", width: "30%" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <Box
                    data-toggle="tooltip"
                    title={value}
                    style={{
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        width: "150px",
                    }}
                    >
                    {value ?? "-"}
                    </Box>
                );
                },
            }
        },
        {
            name: "email",
            label: "EMAIL",
            options: {
                setCellHeaderProps: () => ({ style: { padding: "2px 12px", textAlign: "center", width: "30%" } }),
                setCellProps: () => ({ style: { padding: "0px 12px", whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", width: "30%" } }),
            }
        },
        {
            name: "linkedIn",
            label: "LINKEDIN",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Box style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "30px" }} title={value}>
                                <a href={value} target="_blank" rel="noreferrer">
                                    <LinkedIn />
                                </a>
                            </Box>
                        </>
                    );
                },
            },
        },
        {
            name: "",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <IconButton data-toggle="tooltip"
                            title="Delete" size='small' onClick={() => handleDeleteContact(tableMeta)}>
                            <CloseOutlined color='error' />
                        </IconButton>
                    );
                },
            }
        },
    ];

    const options = {
        filterType: "dropdown",
        selectableRows: "none",
        responsive: "vertical",
    };

    return (
        <Box style={{ height: "500px" }}>
            <MUIDataTable title={"Contacts à importer"} data={importData.contactsToImport} columns={columns} options={options} />
        </Box>
    )
}

export default Step3